export default __webpack_public_path__ + "static/media/loader1.038740d3.gif";